import React, { useEffect, useState } from 'react';
import { useProgressiveNumber } from '../hooks/useProgressiveNumber';
import { Input } from './ui/Input';
import { CheckCircle2 } from 'lucide-react';
interface ProgressiveNumberInputProps {
  type: 'client' | 'contract' | 'nc' | 'invoice' | 'proforma' | 'credit_note' | 'deadline' | 'equipment' | 'improvement';
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  year?: number;
  label?: string;
  required?: boolean;
}
export function ProgressiveNumberInput({
  type,
  value,
  onChange,
  disabled,
  year,
  label,
  required
}: ProgressiveNumberInputProps) {
  const {
    suggestNext
  } = useProgressiveNumber();
  const [suggestedNumber, setSuggestedNumber] = useState('');
  useEffect(() => {
    // Suggest number on mount if no value
    if (!value && onChange) {
      const suggested = suggestNext(type, year);
      setSuggestedNumber(suggested);
      onChange(suggested);
    }
  }, [type, year, onChange, value, suggestNext]);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };
  return <div className="relative" data-id="element-975" data-mp="1zzw10a7au50a">
      <Input label={label || 'Numero'} value={value || ''} onChange={handleChange} disabled={disabled} required={required} endContent={value ? <CheckCircle2 className="h-4 w-4 text-green-500" data-id="element-977" data-mp="2er4tqs6i06hn" /> : null} description={!value && suggestedNumber ? `Numero suggerito: ${suggestedNumber}` : undefined} data-id="element-976" data-mp="250jo4kseq1p8" />
    </div>;
}